(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesDeleteController',TabDevicesDeleteController);

    TabDevicesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabDevices'];

    function TabDevicesDeleteController($uibModalInstance, entity, TabDevices) {
        var vm = this;
        vm.tabDevices = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabDevices.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
